module.exports = __webpack_public_path__ + "static/assets/459e0988ad31fe996181a9dbcbf48a8b.gif";